import React from 'react'
import { useAuthStore } from '@/store/authStore'
import { LessonMaster } from '@/components/lessonmaster/LessonMaster'
import { Navigate } from 'react-router-dom'
import type { Lesson } from '@/types'

interface ProtectedLessonMasterProps {
  lesson: Lesson
}

export function ProtectedLessonMaster({ lesson }: ProtectedLessonMasterProps) {
  const { user, isAuthenticated } = useAuthStore()

  // Must be authenticated
  if (!isAuthenticated || !user) {
    return <Navigate to="/auth" replace />
  }

  // Allow lesson host, captains, and admins
  const isHost = lesson.host?.id === user.id
  const isCaptainOrAdmin = user.role === 'captain' || user.role === 'admin'

  if (!isHost && !isCaptainOrAdmin) {
    return (
      <div className="min-h-screen bg-theme-bg text-theme-text flex items-center justify-center">
        <div className="text-center max-w-md mx-auto p-6">
          <div className="text-6xl mb-4">&#x1F6AB;</div>
          <h1 className="text-2xl font-bold mb-4">Access Denied</h1>
          <p className="text-theme-text-muted mb-4">
            You don't have permission to run this lesson.
          </p>
          <p className="text-sm text-theme-muted mb-6">
            Only captains and admins with course access can use the presenter interface.
          </p>
          <div className="space-y-2">
            <button
              onClick={() => window.history.back()}
              className="ds-btn ds-btn-primary mr-2"
            >
              Go Back
            </button>
            <button
              onClick={() => window.location.href = '/dashboard'}
              className="ds-btn ds-btn-secondary"
            >
              Dashboard
            </button>
          </div>
        </div>
      </div>
    )
  }

  return <LessonMaster />
}
